module.exports = __webpack_public_path__ + "static/media/round-location_on-24px.63c55599.svg";